import {
	createBlueprint,
	CreateBlueprintInfo,
	getBlueprintContent,
	updateBlueprintContent
} from "core/blueprint/base/BlueprintService";
import { Operation } from "rfc6902/diff";
import { v4 as uuidv4 } from "uuid";

const COMPETENCE_LIST_SUFFIX = "competencelists";

export class Competence {
	uuid: string;
	readonly description: string;
	labels: Array<string> = [];
	info = "";
	subcompetences: Competence[] = [];

	constructor(description: string) {
		this.uuid = uuidv4();
		this.description = description;
	}
}

export type CompetenceList = {
	competences: Competence[];
};

export function createCompetenceList(
	info: CreateBlueprintInfo
): Promise<string> {
	return createBlueprint(COMPETENCE_LIST_SUFFIX, info);
}

export function getCompetenceListContent(id: number): Promise<CompetenceList> {
	return getBlueprintContent<CompetenceList>(COMPETENCE_LIST_SUFFIX, id);
}

export function updateCompetenceListContent(
	id: number,
	content: Operation[]
): Promise<void> {
	return updateBlueprintContent(COMPETENCE_LIST_SUFFIX, id, content);
}
